export default "__VITE_ASSET__CndmGcQv__"